import { render } from "./DetailIcon.vue?vue&type=template&id=687dc702&bindings={}"
import script from "./DetailIcon.vue?vue&type=script&lang=ts"
export * from "./DetailIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script